import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Alert,
    CircularProgress
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const userCred = await signInWithEmailAndPassword(auth, email, password);
            console.log("✅ Login successful for:", email);
            console.log("🔑 User ID:", userCred.user.uid);

            // Add a small delay then manually navigate
            setTimeout(() => {
                console.log("🔄 Manually navigating to root...");
                navigate("/");
            }, 1000);

        } catch (err) {
            console.error("❌ Login error:", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2 }}>
                <Typography variant="h5" align="center" gutterBottom>Login</Typography>
                {error && <Alert severity="error">{error}</Alert>}
                <form onSubmit={handleLogin}>
                    <TextField
                        margin="normal"
                        label="Email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <TextField
                        margin="normal"
                        label="Password"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <Button type="submit" variant="contained" fullWidth disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : 'Login'}
                        </Button>
                    </Box>
                </form>
                <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography variant="body2">
                        Don't have an account?{' '}
                        <Button variant="text" size="small" onClick={() => navigate("/signup")}>Sign Up</Button>
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
}

export default LoginPage;